import { isFeatureEnabled } from '~/config/index.js'
import { useGetProfile } from '~/profile/model/profile/hooks.js'

export const useValidateMobileNumberInteraction = () => {
  const { refetch: getProfile } = useGetProfile({
    query: {
      enabled: false,
    },
  })

  return async (): Promise<boolean> => {
    try {
      if (!isFeatureEnabled('interaction.validateMobileNumber')) {
        return false
      }

      const { data: profile } = await getProfile()

      return profile?.mobilePhone?.isValidationRequired ?? false
    } catch {
      return false
    }
  }
}
